
import { Component, Prop,Mixins} from 'vue-property-decorator'
import Common from '@/mixins/common'
import { EventData } from '@/common-datatypes'
import EventDetails from "@/components/EventDetails.vue"

@Component({
  components: {
    EventDetails
  }
})

export default class ModalEventDetails extends Mixins(Common) {
  @Prop({type: String, default: ''}) private message?: string
  @Prop({type: String, default: 'message.yes'}) private confirmText?: string
  @Prop({type: String, default: 'message.no'}) private cancelText?: string
  @Prop({type: String, default: ''}) private errorMessage?: string

  @Prop({type: Object, default: {}}) private theEventData?: EventData

  isActive = true

  get eventId(){
    return this.theEventData?.id || ''
  }

  get title(){
    return this.theEventData?.title || ''
  }

  get isStaff(){
    return this.$store.getters.isStaff
  }

  async created(){
    //
  }

  mounted(){
    //
  }

  onConfirm(yes: boolean) {
    this.$emit("onConfirm", yes)
  }

  async showEvent(){
    if(! this.eventId){
      return
    }

    const location = {
      name: this.isStaff ? 'scheduler' : 'schedule',
      query: {eventId: this.eventId}
    }

    await this.$router.push(location)
  }

  destroyed() {
    console.trace('destroyed');
  }
}
